// extracted by mini-css-extract-plugin
export var checkboxInputRow = "w_sS";
export var checkboxInputColumn = "w_sT";
export var inputOptionRow = "w_qq";
export var inputOptionColumn = "w_qr";